// src/i18n/es/lockerAssignments.js
const lockerAssignments = {
    name: 'Asignación |||| Asignaciones',
    titles: {
        list: 'Asignaciones de Taquillas',
        create: 'Crear Nueva Asignación',
        edit: 'Editar Asignación',
        show: 'Detalles de la Asignación',
        details: 'Ver detalles',
        
        // TagsSection translations
        access_tags_count: 'IDs de Acceso (%{count})',
        no_access_tags: 'No hay IDs de acceso añadidas',
        add_id: 'Añadir ID',
        
        // Tags from TagsPopover - additional translations
        archived_no_edit: 'No se pueden gestionar IDs en asignaciones archivadas'
    },
    edit: {
        success: 'Asignación actualizada correctamente'
    },
    fields: {
        displayReference: 'Referencia',
        guestName: 'Nombre del Huésped',
        guestEmail: 'Email del Huésped',
        guestPhone: 'Teléfono del Huésped',
        roomNumber: 'Número de Habitación',
        checkInDate: 'Fecha de Entrada',
        checkOutDate: 'Fecha de Salida',
        status: 'Estado',
        startsAt: 'Inicia el',
        expiresAt: 'Expira el',
        completedAt: 'Completada el',
        assignedLockers: 'Taquillas Asignadas',
        notes: 'Notas',
        hotel: 'Hotel',
        createdBy: 'Creado por',
        createdAt: 'Fecha de creación',
        updatedAt: 'Última actualización',
        zone: 'Zona',
        no_zone: 'Sin zona',
        available_lockers: 'Taquillas disponibles',
        recommended: 'Recomendado',
        requestedTypes: 'Tipos Solicitados',
        dates: 'Fechas',
        tags: 'IDs',
        usage: 'Uso'
    },
    filters: {
        search: 'Buscar'
    },
    status: {
        pending: 'Pendiente',
        active: 'Activa',
        completed: 'Completada',
        cancelled: 'Cancelada',
        expired: 'Expirada',
        archived: 'Archivada'
    },
    actions: {
        title: 'Acciones',
        view: 'Ver detalles',
        edit: 'Editar',
        delete: 'Eliminar',
        archive: 'Archivar',
        assign_physical: 'Asignar taquillas',
        view_access_logs: 'Ver registro de acceso',
        more_actions: 'Más acciones',
        assignLockers: 'Asignar Taquillas',
        archive_and_release: 'Archivar y Liberar',
        assign: 'Asignar'
    },
    sections: {
        hotel_info: 'Información del Hotel',
        guest_info: 'Información del Huésped',
        requested_types: 'Tipos de Taquillas Solicitadas',
        assignment_period: 'Período de Asignación',
        additional_references: 'Referencias Adicionales',
        general_info: 'Información General',
        assignment_status: 'Estado de la Asignación',
        assigned_lockers_physical: 'Taquillas Asignadas Físicamente'
    },
    dialogs: {
        delete_title: 'Confirmar eliminación',
        delete_content: '¿Está seguro de que desea eliminar esta asignación? Esta acción no se puede deshacer.',
        confirm: 'Confirmar',
        cancel: 'Cancelar',
        delete_message: '¿Está seguro de que desea eliminar esta asignación? Esta acción no se puede deshacer.',
        archive_title: 'Confirmar archivo',
        archive_message: '¿Está seguro de que desea archivar esta asignación?',
        archive_active_title: 'Archivar asignación activa',
        archive_active_message: 'Esta asignación está activa. ¿Está seguro de que desea archivarla?',
        assign_title: 'Asignar Taquillas'
    },
    buttons: {
        add_type: 'Agregar Tipo',
        add_reference: 'Agregar Referencia',
        remove: 'Quitar'
    },
    labels: {
        locker_type: 'Tipo de Taquilla',
        quantity: 'Cantidad',
        key: 'Clave',
        value: 'Valor',
        reference: 'Referencia',
        zone: 'Zona',
        type: 'Tipo',
        no_assigned_lockers: 'Sin taquillas asignadas',
        locker_count: '%{count} taquilla',
        locker_count_plural: '%{count} taquillas',
        no_zone: 'Sin zona',
        no_type: 'Sin tipo',
        requested: 'Solicitadas',
        assigned: 'Asignadas'
    },
    messages: {
        no_hotel_selected: 'No hay hotel seleccionado',
        select_hotel_message: 'Por favor, seleccione un hotel desde el selector superior para crear una asignación.',
        must_add_locker_type: 'Debe agregar al menos un tipo de taquilla',
        loading_locker_types: 'Cargando tipos de taquilla...',
        no_locker_types_configured: 'No hay tipos de taquilla configurados para este hotel',
        
        // LockerRequirementsSection specific translations
        locker_requirements_title: 'Taquillas',
        must_request_locker_help: '* Debe solicitar al menos una taquilla',
        
        // ZonesSection specific translations
        zones_title: 'Zonas Permitidas',
        loading_zones: 'Cargando zonas...',
        no_zones_configured: 'No hay zonas configuradas para este hotel',
        select_zones_label: 'Seleccionar zonas',
        zones_selected_count: '%{selected} de %{total} zonas seleccionadas',
        
        // NotesSection specific translations
        notes_title: 'Notas Adicionales',
        notes_placeholder: 'Observaciones',
        
        add_at_least_one_type: 'Agregue al menos un tipo de taquilla para la asignación',
        assignment_not_editable: 'Esta asignación no puede ser editada porque su estado es:',
        archived_successfully: 'Asignación archivada con éxito',
        deleted_successfully: 'Asignación eliminada con éxito',
        creation_error: 'Error al crear la asignación',
        update_error: 'Error al actualizar la asignación',
        archive_error: 'Error al archivar la asignación',
        delete_error: 'Error al eliminar la asignación',
        delete_success: 'Asignación eliminada con éxito',
        archive_success: 'Asignación archivada con éxito',
        assign_success: 'Taquillas asignadas con éxito',
        assign_error: 'Error al asignar taquillas',
        fetch_lockers_error: 'Error al obtener taquillas',
        no_lockers_available: 'No hay taquillas disponibles',
        loading_lockers: 'Cargando taquillas...',
        no_availability: 'No hay taquillas disponibles para asignar en este momento',
        need_have: 'Necesita %{need}, disponible %{have}',
        requested: 'Solicitadas',
        available: 'Disponibles',
        available_count: 'Disponibles: %{count}',
        select_at_least_one: 'Seleccione al menos una taquilla',
        assigning: 'Asignando...'
    },
    validation: {
        required: 'Este campo es requerido',
        invalid_email: 'Email inválido',
        invalid_phone: 'Teléfono inválido',
        invalid_dates: 'La fecha de salida debe ser posterior a la de entrada',
        no_types: 'Debe solicitar al menos un tipo de taquilla',
        no_quantities: 'Debe solicitar al menos una taquilla'
    },
    notifications: {
        load_lockers_error: 'Error al cargar taquillas disponibles',
        lockers_assigned_success: 'Taquillas asignadas con éxito'
    },
    common: {
        not_assigned: 'No asignado'
    },
    tooltips: {
        more_actions: 'Más acciones'
    },
    assignment: {
        automatic: 'Automática',
        manual: 'Manual'
    },
    placeholders: {
        select_lockers: 'Seleccionar taquillas'
    },
    helpers: {
        selected_count: 'Seleccionadas: %{count}'
    },
    ui: {
        locker_count: '%{count} taquilla||||%{count} taquillas',
        minutes_ago: 'hace %{count} minuto||||hace %{count} minutos',
        hours_ago: 'hace %{count} hora||||hace %{count} horas',
        days_ago: 'hace %{count} día||||hace %{count} días',
        access_count: '%{count} acceso||||%{count} accesos',
        yesterday: 'ayer',
        last_access: 'Último acceso',
        no_name: 'Sin nombre'
    },
    tags: {
        loading_error: 'Error al cargar IDs',
        assignment: 'Asignación',
        manage: 'Gestionar',
        manage_title: 'Gestionar IDs',
        no_tags_message: 'No hay IDs asociadas a esta asignación',
        no_tags_yet: 'Aún no hay IDs',
        current_tags: 'IDs Actuales',
        add_new: 'Añadir Nueva',
        tag_type: 'Tipo de ID',
        tag_code: 'Código de ID',
        enter_code: 'Ingrese el código de la ID',
        code_help: 'Ingrese el código único de la ID',
        description: 'Descripción',
        description_placeholder: 'Descripción opcional de la ID',
        description_help: 'Descripción opcional de la ID',
        add_tag: 'Añadir ID',
        auto_generated: 'Generado Automáticamente',
        generating_qr: 'Generando código QR...',
        loading_types: 'Cargando tipos de ID...',
        added_on: 'Añadida el %{date}',
        
        // TagsSection translations
        access_tags_count: 'IDs de Acceso (%{count})',
        no_access_tags: 'No hay IDs de acceso añadidas',
        add_id: 'Añadir ID',
        
        // Tags from TagsPopover - additional translations
        archived_no_edit: 'No se pueden gestionar IDs en asignaciones archivadas',
        add_tags: 'Añadir ID',
        code_copied: 'Código copiado al portapapeles',
        error_copying: 'Error al copiar código',
        active: 'Activa',
        inactive: 'Inactiva',
        
        // Success messages
        added_successfully: 'ID añadida con éxito',
        removed_successfully: 'ID eliminada con éxito',
        
        // Error messages
        error_empty_code: 'El código de la ID es obligatorio',
        error_no_type_selected: 'Debe seleccionar un tipo de ID',
        error_adding: 'Error al añadir la ID',
        error_removing: 'Error al eliminar la ID'
    },
    access_history: {
        title: 'Historial de Accesos',
        accesses: 'accesos',
        last: 'Último',
        no_access: 'No se encontraron registros de acceso',
        loading_error: 'Error al cargar el historial de accesos',
        error_loading: 'Error al cargar el historial de accesos',
        showing_recent: 'Mostrando %{shown} de %{total} accesos recientes',
        action: {
            opened: 'Abierto',
            closed: 'Cerrado',
            denied: 'Denegado',
            locker_opened: 'Taquilla Abierta',
            locker_closed: 'Taquilla Cerrada',
            locker_denied: 'Acceso a Taquilla Denegado',
            first_use_assigned: 'Primer Uso'
        }
    }
};

module.exports = { lockerAssignments };